
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { ReactElement } from 'react'
import Title from '@jconradi/tutu-porn-components/components/Text/Title'
import HighlightedLink from '@jconradi/tutu-porn-components/components/Text/HighlightedLink'
import { getLayout } from '../components/Layout/Layout'

export default function DMCA(){
    return(
        <section className="flex flex-col p-4 h-full w-full">
            <Title title="Tutu Porn DMCA Copyright Policy"/>
            <p>
            Tutu Media LLC (&ldquo;Company&ldquo;) has adopted the following general policy toward copyright infringement in accordance with the <a href="https://www.copyright.gov/legislation/dmca.pdf" target="_blank" rel="noreferrer" className='text-secondary'>Digital Millennium Copyright Act</a>. The address of the Designated Agent to Receive Notification of Claimed Infringement (&ldquo;Designated Agent&ldquo;) is listed at the end of this policy.
            <br />
            <br />
            </p>
            <p>
                Procedure for Reporting Copyright Infringement:
            </p>
            <ol className='my-5 ml-5'>
                <li key="1">1. A physical or electronic signature of a person authorized to act on behalf of the owner of the copyright that has been allegedly infringed;</li>
                <li key="2">2. Identification of works or materials being infringed;</li>
                <li key="3">3. Identification of the material that is claimed to be infringing including information regarding the location of the infringing materials that the copyright owner seeks to have removed, with sufficient detail so that Company is capable of finding and verifying its existence;</li>
                <li key="4">4. Contact information about the notifier including address, telephone number and, if available, e-mail address;</li>
                <li key="5">5. A statement that the notifier has a good faith belief that the material is not authorized by the copyright owner, its agent, or the law; and</li>
                <li key="6">6. A statement made under penalty of perjury that the information provided is accurate and the notifying party is authorized to make the complaint on behalf of the copyright owner.</li>
            </ol>
            <p>
            If you believe that material or content residing on or accessible through Company&quot;s websites or services infringes a copyright, please send a notice of copyright infringement containing the following information to the Designated Agent listed below:
            If we receive a takedown notice in accordance with the foregoing, we will remove the material cited in the notice and attempt to notify any user who uploaded the allegedly infringing material if we have their contact information. Any such user will have the opportunity to submit a “counter-notice” as set forth below. If we determine that any user has repeatedly infringed upon the intellectual property rights of others, we will disable any accounts that user has with us when appropriate.
            <br />
            <br />
            </p>
            <p>
            Please contact the Designated Agent to Receive Notification of Claimed Infringement for Company at <HighlightedLink href="mailto:dmca@tutu.porn" text='dmca@tutu.porn'/> . Important: Please email us in urgent cases to avoid any delays.
            </p>
            <div className="bg-outline py-4 mt-2 rounded-2xl flex flex-col items-center justify-center text-left  text-[0.875rem] leading-[24px]">
                <p>Tutu Media LLC</p>
                <p>Subject: Tutu Media DMCA</p>
                <p>5940 S. Rainbow Boulevard</p>
                <p>Las Vegas, NV 89118</p>
                <p>United States of America</p>
            </div>
        </section>
    )
}

DMCA.getLayout = (page: ReactElement) => getLayout(page)

// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/dmca',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  